export enum GameState {
    INSTRUCTIONS,
    ROUND,
    ROUND_RESULT,
    GAME_END,
    SCOREBOARD,
    REWARD,
    THANK_YOU
}